import { render, staticRenderFns } from "./SelectedActivities.vue?vue&type=template&id=7863b10c&scoped=true&"
import script from "./SelectedActivities.vue?vue&type=script&lang=js&"
export * from "./SelectedActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863b10c",
  null
  
)

export default component.exports